<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules" :disabled="!isInfo">
      <a-form-model-item label="退款单编号" prop="id" >
        <a-input disabled v-model="form.id" placeholder="请输入退款单编号" />
      </a-form-model-item>
      <a-form-model-item label="用户名称" prop="nickname" >
        <a-input disabled v-model="form.nickname" placeholder="请输入用户" />
      </a-form-model-item>
      <a-form-model-item label="售后类型" prop="type" >
        <span v-if="form.type == 1">退款</span>
        <span v-if="form.type == 2">退货退款</span>
      </a-form-model-item>
      <a-form-model-item label="产品名称" prop="prodName" >
        <a-input disabled v-model="form.prodName" placeholder="请输入产品名称" />
      </a-form-model-item>
      <a-form-model-item label="商品图片" prop="picture" >
        <img v-viewer  style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;" v-if="form.picture"
             :src="form.picture" preview="头像"/>
      </a-form-model-item>
      <a-form-model-item label="sku名称" prop="skuName" >
        <a-input disabled v-model="form.skuName" placeholder="请输入sku名称" />
      </a-form-model-item>
      <a-form-model-item label="售后金额" prop="refundMoney" >
        <a-input disabled v-model="form.refundMoney" placeholder="请输入售后金额" />
      </a-form-model-item>
      <a-form-model-item label="售后现金券额度" prop="refundVoucher" >
        <a-input disabled v-model="form.refundVoucher" placeholder="请输入售后现金券额度" />
      </a-form-model-item>
<!--      <a-form-model-item label="售后积分数" prop="refundScores" >-->
<!--        <a-input disabled v-model="form.refundScores" placeholder="请输入售后积分数" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="售后说明" prop="content" v-if="form.content">
        <a-input disabled type="textarea" v-model="form.content" />
      </a-form-model-item>
      <a-form-model-item label="售后凭证" prop="image" v-if="form.image">
        <img v-viewer  style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;"
          v-for="item in form.image.split(',')"   :src="item" preview="头像"/>
      </a-form-model-item>
      <a-form-model-item label="退换说明" prop="exchangeReason" v-if="form.exchangeReason">
        <a-input disabled type="textarea" v-model="form.exchangeReason" />
      </a-form-model-item>
      <a-form-model-item label="退换说明图片" prop="exchangeImage" v-if="form.exchangeImage">
        <img v-viewer  style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;"
             v-for="item in form.exchangeImage.split(',')"   :src="item" preview="头像"/>
      </a-form-model-item>
      <a-form-model-item label="物流公司" prop="logisticsCompany" v-if="form.logisticsCompany">
        <a-input :disabled="isInfo == true" v-model="form.logisticsCompany" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="物流单号" prop="logisticsNumber" v-if="form.logisticsNumber">
        <a-input :disabled="isInfo == true" v-model="form.logisticsNumber" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="联系电话" prop="phone" v-if="form.phone">
        <a-input :disabled="isInfo == true" v-model="form.phone" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="售后状态" prop="status" v-if="!isInfo">
        <a-radio-group v-model="form.status" v-if="form.type == 1" @change="onStatus">
          <!-- <a-radio :value="1">待审核</a-radio> -->
          <a-radio :value="2">同意</a-radio>
<!--          <a-radio :value="-1">驳回</a-radio>-->
        </a-radio-group>
        <a-radio-group v-model="form.status" v-if="form.type == 2" @change="onStatus">
          <!-- <a-radio :value="1">待审核</a-radio> -->
          <a-radio :value="3">同意</a-radio>
<!--          <a-radio :value="-1">驳回</a-radio>-->
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="售后状态" prop="status"  v-if="isInfo">
        <span v-if="form.status ==1">待审核</span>
        <span v-if="form.status ==2">待退款</span>
        <span v-if="form.status ==3">待寄回</span>
        <span v-if="form.status ==4">已完成</span>
        <span v-if="form.status ==5">已撤销</span>
        <span v-if="form.status ==-1">驳回</span>
      </a-form-model-item>
      <a-form-model-item label="驳回原因" prop="rejectReason" v-if="form.status == -1">
        <a-input :maxLength="50" :disabled="isInfo == true" v-model="form.rejectReason" placeholder="请输入驳回原因" />
      </a-form-model-item>
      <a-form-model-item label="寄回地址" prop="refundAddressId" v-if="form.status != 1 && form.status != -1 && form.type == 2 && form.orderType != 1">
        <a-select :disabled="formTitle == '详情'" v-model="form.refundAddressId"  show-search
                  :filter-option="filterOption">
          <a-select-option v-for="item in refundAddressList" :value="item.id">{{item.returnAddress}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button v-if="!isInfo" type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getOrderRefund, addOrderRefund, updateOrderRefund, updateOrderDirect} from '@/api/orderRefund/orderRefund'
import Editor from '@/components/Editor'
import {listAddress} from "@/api/refund/address";

export default {
  name: 'ForceCreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      isInfo: false,
      refundAddressList:[],
      // 表单参数
      form: {
        returnAddress:"",
        id: null,
        orderType:null,
        refundNo: null,
        refundAddressId:null,
        userId: null,

        nickname: null,

        goodsId: null,

        prodName: null,

        skuId: null,

        picture: null,

        skuName: null,

        orderId: null,

        orderItemId: null,

        refundMoney: null,

        refundVoucher: null,

        refundScores: null,

        type: null,

        content: null,

        image: null,

        status: 0,
        exchangeImage:null,
        exchangeReason:null,
        logisticsCompany: null,

        logisticsNumber: null,

        phone: null,

        rejectReason: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        status: [
          { required: true, message: '售后状态 不能为空', trigger: 'blur' }
        ],
        rejectReason: [
          { required: true, message: '驳回原因 不能为空', trigger: 'blur' }
        ],
        refundAddressId: [
          { required: true, message: '寄回地址 不能为空', trigger: 'blur' }
        ],
      }
    }
  },
  filters: {
  },
  created () {
    this.initAddress()
  },
  activated() {
    this.initAddress()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onStatus(e){
      this.form.status = e.target.value
      console.log(this.form.status,"val")
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    filterOption(input, option) {
      this.valGuiGe = input
      this.form.specIds = input

      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    /*initAddress(){
      listAddress().then(res=>{
        this.refundAddressList = res.data
      })
    },*/

    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        refundNo: null,
        userId: null,
        orderType:null,
        nickname: null,
        goodsId: null,
        refundAddressId: null,
        prodName: null,
        skuId: null,
        picture: null,
        skuName: null,
        orderId: null,
        orderItemId: null,
        refundMoney: null,
        refundVoucher: null,
        refundScores: null,
        type: null,
        content: null,
        image: null,
        status: 0,
        exchangeImage:null,
        exchangeReason:null,
        logisticsCompany: null,
        logisticsNumber: null,
        phone: null,
        rejectReason: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.open = true
      this.reset()
      this.formType = 2
      const id = row.id
      getOrderRefund({"id":id}).then(response => {
        this.isInfo = false
        this.form = response.data
        console.log("type:",this.form.type,"status:",this.form.status)
        this.formTitle = '审核'
      })
    },
    handleInfo(row){
      this.reset()
      this.formType = 2
      const id = row.id
      getOrderRefund({"id":id}).then(response => {
        this.isInfo = true
        this.form = response.data
        this.open = true
        this.formTitle = '详情'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          console.log(this.form,"form")
          if (this.form.id !== undefined && this.form.id !== null) {
            updateOrderDirect({refundAddressId:this.form.refundAddressId,id:this.form.id,status:this.form.status,rejectReason:this.form.rejectReason,returnAddress:this.form.returnAddress}).then(response => {
              if(response.success){
                this.$message.success(
                  '操作成功',
                  3
                )
                this.open = false
                this.$emit('ok')
              }else{
                this.$message.error(response.message)
              }

            }).finally(() => {
              this.submitLoading = false
            })
          }
            else {
            addOrderRefund(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
